import { useLocation } from "react-router-dom";


export const useAppRoutePath = () => useLocation().pathname;